import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantMeetingsRoot = () => {
  useProtected();

  return <Outlet />;
};

export { MeetingsPage } from "./Meetings";
export { MeetingPage } from "./Meeting";
